import React, { Component } from 'react';
import Paper from '@mui/material/Paper';
import LinearProgress from '@mui/material/LinearProgress';
import { connect } from 'react-redux';
import { showMessage } from '../../actions/uiActions';
import './fax.css';
import faxApi from '../../api/fax';

class Fax extends Component {
  state = {
    recipient: '',
    from: '',
    to: '',
    message: '',
    file: null,
    preview: null,
    sending: false,
  };

  handleInputChange = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };

  removeFile = () => {
    this.setState({
      file: null,
      preview: null,
    });
  };

  handleFileUpload = ({ target }) => {
    this.setState({
      file: target.files[0],
      preview: URL.createObjectURL(target.files[0]),
    });
  };

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  sendFax = async () => {
    const { recipient, from, message, to, file, preview } = this.state;
    if (!recipient || !from || !to || !message || !file) {
      return this.props.showMessage('All fields are required');
    }
    this.setState({ sending: true });
    try {
      const base64file = await this.toBase64(file);
      const data = await faxApi.sendFax({
        recipient,
        from,
        message,
        to,
        file: base64file,
      });
      this.setState({
        recipient: '',
        from: '',
        to: '',
        message: '',
        file: null,
        preview: null,
      });
      this.props.showMessage('Fax successfully sent');
    } catch (error) {
      this.props.showMessage('An error occurred while sending fax');
    } finally {
      this.setState({ sending: false });
    }
  };

  render() {
    const { recipient, from, to, message, preview, sending } = this.state;
    return (
      <section className='animated fadeIn'>
        <header>
          <h1>Fax</h1>
        </header>
        <div className='col-12'>
          <Paper style={{ display: 'flex' }} elevation={1}>
            <div className='padding col-12'>
              <h4>Send Fax</h4>
              <div className='row'>
                <p className='col-12'>
                  Use this form to send fax to individuals
                </p>
                <div className='col-sm-12'>
                  <div className='form-group'>
                    <label htmlFor='recipient'>Recipient</label>
                    <input
                      type='text'
                      onChange={this.handleInputChange}
                      className='form-control'
                      name='recipient'
                      id='recipient'
                      value={recipient}
                      placeholder='Fax number'
                    />
                  </div>
                </div>
                <p className='col-12'>Enter cover page details</p>
                <div className='col-md-6 col-sm-12'>
                  <div className='form-group'>
                    <label htmlFor='to'>To</label>
                    <input
                      type='text'
                      onChange={this.handleInputChange}
                      className='form-control'
                      name='to'
                      id='to'
                      value={to}
                    />
                  </div>
                </div>
                <div className='col-md-6 col-sm-12'>
                  <div className='form-group'>
                    <label htmlFor='from'>From</label>
                    <input
                      type='text'
                      onChange={this.handleInputChange}
                      className='form-control'
                      name='from'
                      value={from}
                    />
                  </div>
                </div>
                <div className='col-sm-12'>
                  <div className='form-group'>
                    <label htmlFor='message'>Message</label>
                    <textarea
                      type='text'
                      onChange={this.handleInputChange}
                      className='form-control'
                      name='message'
                      rows='5'
                      value={message}
                    />
                  </div>
                </div>
                {preview && (
                  <embed src={preview} className='col-sm-12' height='500' />
                )}
                {preview && (
                  <>
                    <div className='fax-actions'>
                      {!sending && (
                        <button
                          className='btn btn-primary btn-standard'
                          onClick={() => this.removeFile()}
                        >
                          Remove File
                        </button>
                      )}
                      <button
                        disabled={sending}
                        className='btn btn-primary btn-standard'
                        onClick={() => this.sendFax()}
                      >
                        {sending ? 'Sending...' : 'Send Fax'}
                      </button>
                    </div>
                    {sending && <LinearProgress style={{ width: '100%' }} />}
                  </>
                )}
                {!preview && (
                  <div className='col-sm-12'>
                    <input
                      accept='.pdf'
                      type='file'
                      id='file-input'
                      className='file-input'
                      onChange={this.handleFileUpload}
                    />
                    <label htmlFor='file-input' className='file-upload'>
                      Upload file
                    </label>
                  </div>
                )}
              </div>
            </div>
          </Paper>
        </div>
      </section>
    );
  }
}

export default connect(null, { showMessage })(Fax);
